import { POST,postFile } from "../../index";

export const getTrainList = (param) => POST("/v1/train/getTrainList", param);
export const insertTrain = (param) => postFile("/v1/train/insertTrain", param);
export const updateTrain = (param) => postFile("/v1/train/updateTrain", param);
export const deleteTrain = (param) => POST("/v1/train/deleteTrain", param);
export const updateFixed = (param) => POST("/v1/train/updateFixed", param);
export const getExamDriver = (param) => POST("/v1/train/getExamDriver", param);
export const getExamQuestion = (param) => POST("/v1/train/getExamQuestion", param);
